import clsx from 'clsx';
import { twMerge } from 'tailwind-merge';

export interface PromotionProps {
  className?: string;
  innerClassName?: string;
  percent?: number;
  size?: 'xs' | 'sm' | 'lg' | 'md' | 'base';
}

export function Promotion({
  className = '',
  innerClassName = '',
  percent,
  size = 'sm',
}: PromotionProps) {
  if (!percent) return null;

  return (
    <div className={className}>
      <div
        className={twMerge(
          clsx(
            'rounded-full relative  bg-neutral-80 text-neutral-0 flex items-center justify-center',
            '[print-color-adjust:exact]',
            {
              'size-10 hd-sm': size === 'xs',
              'size-10 hd-sm sm:size-14 sm:hd-md': size === 'sm',
              'h-20 w-20 hd-lg md:h-24 md:w-24 md:hd-lg lg:h-28 lg:w-28 lg:hd-xl':
                size === 'lg',
              'size-24 hd-xl': size === 'md',
              'size-14 hd-md': size === 'base',
            },
            innerClassName
          )
        )}
      >
        {percent}%
      </div>
    </div>
  );
}

export default Promotion;
